module.exports = __webpack_public_path__ + "static/media/profile.0eca6d1a.jpg";